var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-4 relative rounded-md shadow-md text-sm text-gray-800 leading-5",class:[
    _vm.color ? ("bg-" + _vm.color + "-100 border-" + _vm.color + "-500 notice-" + _vm.color) : '',
    _vm.$i18n.locale == 'fa' ? 'border-r-4' : 'border-l-4' ]},[_c('p',[(_vm.noTitle)?_c('b',{staticClass:"ml-2"},[_vm._v(" "+_vm._s(_vm.$t("ATTENTION"))+" ")]):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }